import "./ServiceModal.css";
import { getServiceImages } from "../utils/loadServiceImages";

export default function ServiceModal({ service, onClose }) {
  const images = getServiceImages(service.folder);

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>✕</button>
        <h2>{service.title}</h2>

        <div className="modal-gallery">
          {images.length === 0 && <p>Keine Bilder vorhanden</p>}
          {images.map((img, i) => (
            <img key={i} src={img} alt="" loading="lazy" />
          ))}
        </div>
      </div>
    </div>
  );
}